// recentWatched — small LRU cache of the last N videos the current
// device watched in the home feed. Used by the Marketplace
// "Make an Offer on a Video" panel so Producers can browse offers
// against videos they've recently shown interest in.
//
// Storage: localStorage (per-device, no backend sync). A user signing
// in from a fresh device sees an empty list — that's intentional and
// matches the privacy expectations of an "anonymous offer" market.

const KEY = "globaleyes:recentWatched:v1";
const MAX = 5;

export const pushRecentWatched = (video) => {
  if (!video || !video.id || !video.title) return;
  try {
    // Trim down to the minimal shape we need to render the row +
    // popover later. Saves localStorage bytes and avoids leaking
    // unrelated state (comments, hot-flag, etc).
    const entry = {
      id: video.id,
      title: video.title,
      producer_username: video.producer_username || video.username || null,
      thumbnail_url: video.thumbnail_url || null,
      views: video.views || 0,
      applause_count: video.applause_count || 0,
      comment_count: video.comment_count || 0,
      created_at: video.created_at || null,
      location: video.location || null,
      city: video.city || null,
      country: video.country || null,
      watched_at: new Date().toISOString(),
    };
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    // LRU: drop any prior occurrence, prepend, truncate.
    const deduped = list.filter((v) => v.id !== entry.id);
    deduped.unshift(entry);
    localStorage.setItem(KEY, JSON.stringify(deduped.slice(0, MAX)));
  } catch (_) {
    // localStorage may be unavailable in private mode — silently skip
  }
};

export const getRecentWatched = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (_) {
    return [];
  }
};

export const clearRecentWatched = () => {
  try { localStorage.removeItem(KEY); } catch (_) { /* noop */ }
};
